export default{
    
    lista:{
        method:'get',
        url:'previdencia/lista'
    },
    cadastra:{
        method:'post',
        url:'previdencia/cadastro'
    },
    delete:{
        method:'delete',
        url:'previdencia/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'previdencia/editar{/id}'
    },
    update:{
        method:'post',
        url:'previdencia/update'
    },
    irrf:{
        method:'get',
        url:'irrf/busca{/id}'
    },
}